<template>
  <ImageCheckboxGroup
    v-if="variants.length"
    v-model="valueModel"
    :label="label"
    :avatar-props="{
      size: 24,
      fillColor: 'transparent',
    }"
    name="platforms"
    v-bind="{ variants }"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { prop } from '@/utils/factories';
import ImageCheckboxGroup from '@/components/common/ImageCheckboxGroup';

export default {
  components: {
    ImageCheckboxGroup,
  },

  props: {
    value: prop(Array),
    label: prop(String),
  },

  computed: {
    // TODO: Use mapState
    ...mapGetters(['platforms']),

    variants() {
      return this.platforms.map(({ logo, id }) => ({
        value: id,
        img: logo.uri,
      }));
    },
    valueModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },

  created() {
    this.fetchPlatforms();
  },

  methods: {
    ...mapActions(['fetchPlatforms']),
  },
};
</script>

<style lang="scss"></style>
